import {
  GET_PROFILE,
  UPDATE_INFO,
  GET_ALL_INVESTOR,
  GET_STRATEGY,
  UPDATE_COVER_IMAGE,
  UPDATE_COMPANY_LOGO,
  SEARCH_PMRESULT,
  SEARCH_REPORTRESULT,
  SEARCH_RPRESULT,
  GET_FUND_DETAIL,
  UPLOAD_FILE_DECK,
  UPLOAD_TEAR_SHEET,
  GET_CLOUD_DECKS,
  GET_MEDIA,
  GET_INVESTED_ALLOCATORS,
  GET_ALLOCATOR_USERS,
  CREATE_CHAT_ROOM,
} from "./constants";

export const getMyProfile = (payload) => {
  return {
    type: GET_PROFILE,
    payload,
  };
};

export const updateInfo = (payload, onSuccess) => {
  return {
    type: UPDATE_INFO,
    payload,
    onSuccess,
  };
};

export function getallInvestor(payload) {
  return {
    type: GET_ALL_INVESTOR,
    payload,
  };
}

export function getAllStrategy() {
  return {
    type: GET_STRATEGY,
  };
}

export function updateTenantCoverImage(payload, onSuccess, onCloseModal) {
  return {
    type: UPDATE_COVER_IMAGE,
    payload,
    onSuccess,
    onCloseModal
  };
}

export function updateTenantCompanyLogo(payload, onSuccess, onCloseModal) {
  return {
    type: UPDATE_COMPANY_LOGO,
    payload,
    onSuccess,
    onCloseModal
  };
}

export function getPerformanceMetricsSearchResult(payload) {
  return {
    type: SEARCH_PMRESULT,
    payload
  };
}

export function GetRiskReportSearchResult(payload) {
  return {
    type: SEARCH_RPRESULT,
    payload
  };
}
export function RiskReportSearchResultByMonth(payload) {
  return {
    type: SEARCH_REPORTRESULT,
    payload
  };
}

export function getFundDetails(id) {
  return {
    type: GET_FUND_DETAIL,
    id,
  };
}

export function uploadFileDeck(payload, onSuccessAlert, onCloseModal) {
  return {
    type: UPLOAD_FILE_DECK,
    payload,
    onSuccessAlert,
    onCloseModal
  };
}

export const uploadTearSheet = (payload, onSuccess , onCloseModal) => {
  return {
    type: UPLOAD_TEAR_SHEET,
    payload,
    onSuccess,
    onCloseModal
  };
};

export function getCloudDecks(payload) {
  return {
    type: GET_CLOUD_DECKS,
    payload
  };
}

export function getAllMedia(payload) {
  return {
    type: GET_MEDIA,
    payload
  };
}

export function getInvestedCompaniesList() {
  return {
    type: GET_INVESTED_ALLOCATORS,
  };
}

export function getAllocatorUserList(payload) {
  return {
    type: GET_ALLOCATOR_USERS,
    payload
  };
}

export function createChatRoom(payload, callback) {
  return {
    type: CREATE_CHAT_ROOM,
    payload,
    callback
  };
}


